import { render, staticRenderFns } from "./CStylesHeader.vue?vue&type=template&id=2e3bedcf&"
import script from "./CStylesHeader.vue?vue&type=script&lang=js&"
export * from "./CStylesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports